import { getEnv } from "./data/env";

export let appConfig = null;

export function initAppConfig() {
    appConfig = {
        "PUBLIC_URL": getEnv('PUBLIC_URL'),
        "basename": window.appConfig == null ? getEnv('PUBLIC_URL') : window.appConfig.BASENAME,
        ...(window.appConfig == null ? require(`./config/${getEnv('REACT_APP_XSPORT_CUSTOMER')}.conf.json`) : window.appConfig)
    };
    
    appConfig.ROUTES.sectionFromPath = function(path, sections) {
        return Object.keys(sections).find((k) => sections[k] === path || sections[k] === `${path}/`);
    };
    
    appConfig.ROUTES.pathFromSection = function(route,section) {
        return appConfig.ROUTES[route][section];
    };
    
    appConfig.ROUTES.routeFromPath = function(path) {
        var toReturn = null;
        //console.log('--->'+path)
        path && Object.entries(appConfig.ROUTES).forEach(function([k,v]) {
            if (!(typeof v =='function')) {
                if (Object.keys(v).find((k2) => v[k2] == path || v[k2] == `${path}/`)) {
                    //console.log('aaa'+k)
                    toReturn =  k;
                }
            }
        });
        return toReturn;
    }

    window.appConfig = appConfig;
    window.blockHistoryChanges = function() {
        return window.appConfig?.SHOP_MODE;
    }
    appConfig.BASENAME = (window.appConfig == null) ? getEnv('PUBLIC_URL') : window.appConfig.BASENAME;
}
